export const storeManageListNewData = [
  {
    id: 'baseInfo',
    title: '',
    data: [
      {
        id: 'storeName',
        name: '1.新增制度数量',
        placeholder: '',
        type: 'input',
        checkType: 'required',
        newDisabled: false,
        editDisabled: false,
        newShow: true,
        editShow: true,
        value: '',
        options: [],
        expand: {},
        jpath: 'storeName'
      },
      {
        id: 'description',
        name: '2.简介博物馆章程制定执行情况',
        placeholder: '',
        type: 'textarea',
        checkType: 'required',
        newDisabled: false,
        editDisabled: false,
        newShow: true,
        editShow: true,
        value: '',
        options: [],
        expand: {
          autosize: {minRows: 4, maxRows: 10}
        },
        jpath: 'description'
      },
      {
        id: 'businessLicenseImg',
        name: '',
        placeholder: '',
        type: 'img',
        checkType: 'required',
        newDisabled: false,
        editDisabled: false,
        newShow: true,
        editShow: true,
        value: [],
        options: [],
        expand: {
          limit: 1
        },
        jpath: 'businessLicenseImg'
      },
      {
        id: 'description',
        name: '3.简介博物馆中长期发展规划编制、执行情况',
        placeholder: '',
        type: 'textarea',
        checkType: 'required',
        newDisabled: false,
        editDisabled: false,
        newShow: true,
        editShow: true,
        value: '',
        options: [],
        expand: {
          autosize: {minRows: 4, maxRows: 10}
        },
        jpath: 'description'
      },
      {
        id: 'businessLicenseImg',
        name: '',
        placeholder: '',
        type: 'img',
        checkType: 'required',
        newDisabled: false,
        editDisabled: false,
        newShow: true,
        editShow: true,
        value: [],
        options: [],
        expand: {
          limit: 1
        },
        jpath: 'businessLicenseImg'
      },
      {
        id: 'description',
        name: '4.简介博物馆内部管理制度体系建设、完善、更新情况',
        placeholder: '',
        type: 'textarea',
        checkType: 'required',
        newDisabled: false,
        editDisabled: false,
        newShow: true,
        editShow: true,
        value: '',
        options: [],
        expand: {
          autosize: {minRows: 4, maxRows: 10}
        },
        jpath: 'description'
      },
      {
        id: 'businessLicenseImg',
        name: '',
        placeholder: '',
        type: 'img',
        checkType: 'required',
        newDisabled: false,
        editDisabled: false,
        newShow: true,
        editShow: true,
        value: [],
        options: [],
        expand: {
          limit: 1
        },
        jpath: 'businessLicenseImg'
      },
    ]
  }
];
